import '../CsvJsonInfoPages.scss';


function SelectableOptions() {

    const data = [
        { field: 1, description: 'CAP ID Number (Int)' },
        { field: 2, description: 'Option Code (Int)' },
        { field: 3, description: 'Date Option Effective From (Date)' },
        { field: 4, description: 'Date Option Effective To (Blank if still current) (Date)' },
        { field: 5, description: 'Date Option was last modified (Date)' },
        { field: 6, description: 'Basic Price (Money)' },
        { field: 7, description: 'VAT (Money)' },
        { field: 8, description: 'Price on application (POA) (Boolean)' },
        { field: 9, description: 'Default Option (Boolean)' },
    ];


    return (
        <div className='csv-json-info-pages-container'>
            <h1>New Vehicle Data Enhanced - Selectable Options</h1>
            <p>This file contains the optional items which can chosen on a vehicle. It is a complete history from 1998, so will contain both current and non-current vehicles. <br /><br />
                <b>File Naming Convention</b><br /><br />
                The Filename is dependant on the product being produced as follows.<br /><br />

                CAR_yyyy-mm-dd_NVDOptions.txt<br />
                LIGHTS_yyyy-mm-dd_NVDOptions.txt<br />
                HEAVIES_yyyy-mm-dd_NVDOptions.txt<br />
                BIKES_yyyy-mm-dd_NVDOptions.txt<br /><br />

                Note: yyyy-mm-dd represents the date of the product. E.g. 2003-07-01 would represent the date 1st July 2003.
            </p>
            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <p>
                Notes:<br/>
                Dates are outputted in Universal Date Format (yyyy/mm/dd) E.g. A date of  2003/07/01 would represent 1st July 2003.<br/>
                Boolean fields are outputted as 0 and 1 where 1=TRUE or 0=FALSE.
            </p>
        </div>
    );
}

export default SelectableOptions;
